import "./Services.module.css";
import Navigation from "@/reusable_sections/Header";
import YourPersonalIntelligenceCenter from "./sections/YourPersonalIntelligenceCenter";
import ServicesAndInnovations from "./sections/ServicesAndInnovations";
import BookConsultation from "./sections/BookConsultation";
import SiteFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Navigation />
      <YourPersonalIntelligenceCenter />
      <ServicesAndInnovations />
      <BookConsultation />
      <SiteFooter />
    </div>;
}